export const numberToStringWithDecimals = (number: number, decimals: number): string =>
  number.toFixed(decimals).toString()
